import 'babel-polyfill';
import promise from 'es6-promise'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/font/iconfont.css'

Vue.config.productionTip = false
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
//引入iview
import iView from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(iView);
import Region from 'v-region'
Vue.use(Region);
//导入样式
import '@/css/basic_pc.css'
import '@/css/extend.css'
import '@/css/style.less'
import axios from 'axios';
Vue.prototype.$axios = axios;


//初始化执行权限判定
import "@/utils/permission.js"

//自定义权限指令
import "@/utils/instruction"

//导入api
import api from '@/api/index.js'
import common from '@/utils/common.js'

Vue.prototype.$api = api;
Vue.prototype.$common = common;
Vue.prototype.$bus=new Vue();
Vue.prototype.$Message.config({
    duration: 3
});

promise.polyfill();
// eslint-disable-next-line no-undef
document.title = indexTitle
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')